import type { GolfCart } from '../types/cart.types';

export const golfCarts: GolfCart[] = [
  {
    id: 'premium-6-seater',
    name: 'Premium 6-Seater',
    description: 'Extended Range',
    imageUrl: '/golfcart_blue_six_seats.png',
    imageGradient: 'from-blue-100 to-blue-200',
    badge: {
      text: 'Most Popular',
      color: 'blue',
    },
    batteryType: 'Lithium Battery',
    passengers: 6,
    features: ['6 Passengers', 'Extended Range'],
    pricing: {
      label: 'Starting at',
      amount: 190,
      period: '/4 hours',
    },
  },
  {
    id: 'family-cruiser',
    name: 'Family Cruiser',
    description: 'Spacious Seating',
    imageUrl: '/golfcart_family.jpeg',
    imageGradient: 'from-red-100 to-orange-100',
    badge: {
      text: 'Great for Groups',
      color: 'orange',
    },
    batteryType: 'Lithium Battery',
    passengers: 6,
    features: ['6 Passengers', 'Spacious Seating'],
    pricing: {
      label: 'Full Day',
      amount: 310,
      period: '/8 hours',
    },
  },
  {
    id: 'executive-model',
    name: 'Executive Model',
    description: 'Luxury Features',
    imageUrl: '/Model_cart.jpeg',
    imageGradient: 'from-gray-200 to-gray-300',
    badge: {
      text: 'Premium',
      color: 'purple',
    },
    batteryType: 'Lithium Battery',
    passengers: 6,
    features: ['6 Passengers', 'Luxury Features'],
    pricing: {
      label: 'Weekly Special',
      amount: 980,
      period: '/week',
    },
  },
];